import { render, staticRenderFns } from "./ServicesTsp.vue?vue&type=template&id=4f2d3c4d&scoped=true"
import script from "./ServicesTsp.vue?vue&type=script&lang=js"
export * from "./ServicesTsp.vue?vue&type=script&lang=js"
import style0 from "./ServicesTsp.vue?vue&type=style&index=0&id=4f2d3c4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d3c4d",
  null
  
)

export default component.exports